import React, { useEffect, useState } from 'react';
import {
    Grid,
    Button,
    Dialog,
    DialogTitle,
    DialogActions,
    DialogContent,
    TextField,
} from "@material-ui/core";

//import { useSelector } from 'react-redux';
import { TIPO_LINEA } from '../ModalAddLine';
import { ModalAddLineCampos } from '../../ModalAddLineCampos';
import BuscadorMateriales from '../../../../autorizaciones/UI/BuscadorMateriales';
import BuscadorPractica from '../../../../turnos/coseguros/BuscadorPractica';
import { LIQUIDACIONES_LINEA_COMPORBANTE, OBRAS_SOCIALES } from '../../../../../utils/constants';
import { startAlerta } from '../../../../../actions/ui/alertas';
import { modificarLineaInsumo, modificarLineaPrestacion } from '../../../../../actions/liquidaciones/liquidaciones';
import { useDispatch } from 'react-redux';

export const ModalModificarLinea = (props) => {

    const dispatch = useDispatch();
    const { open, closeModalHandler, esLineaCodigoLiq, comprobanteSeleccionado,
        lineaComprobante, tipoLinea, title, item, importeDebito, setImporteDebito } = props;

    // const { lineasPrestacionComprobante, lineasInsumosComprobante } = useSelector(
    //     (state) => state.liquidaciones
    // );

    const [idSolicitud, setIdSolicitud] = useState();


    const [codigoPractica, setCodigoPractica] = useState(item?.idCodNom ? {
        id: item?.idCodNom,
        codNom: item?.codNom,
        desNom: item?.desNom
    } : null);
    const [codigoMaterial, setCodigoMaterial] = useState(item?.codMat ? {
        codigo: item?.codMat,
        descripcion: item?.desMat,
        codigoNum: item?.idMaterial
    } : null);
    const [soloPrecarga, setSoloPrecarga] = useState(tipoLinea === TIPO_LINEA.IdSolicitud);

    // CAMPOS GRABAR SIN PRECARGAR
    const [importe, setImporte] = useState(item?.importe);
    const [coseguroFacturado, setCoseguroFacturado] = useState(item?.coseguroFacturado);
    const [cantidad, setCantidad] = useState(item?.cantidad);
    const [idCategoria, setIdCategoria] = useState(item?.idCategoria);
    const [afiliadoTemp, setAfiliadoTemp] = useState(item?.idAfiliado ? {
        id_afiliado: item?.idAfiliado,
        apellido_y_nombre: item?.apellidoNombre,
        carnet: item?.carnet,
        fecha_baja: item?.fechaBajaAfiliado,
        nro_doc: item?.nroDocumento,
        cuil: item?.cuil
    } : null);
    const [afiliadoExternoTemp, setAfiliadoExternoTemp] = useState(item?.idAfiliadoExterno ? {
        id_afiliado: item?.idAfiliadoExterno,
        apellido_y_nombre: item?.apellidoNombre,
        carnet: item?.carnet,
        fecha_baja: item?.fechaBajaAfiliado,
        nro_doc: item?.nroDocumento,
        cuil: item?.cuil
    } : null);
    const [nroValidacion, setNroValidacion] = useState(item?.nroValidacion);
    const [afiInexistente, setAfiInexistente] = useState(item?.afiliadoInexistente);
    const [idSolicitudLinea, setIdSolicitudLinea] = useState(item?.idSolicitud);
    //const [fechaPrestacion, setFechaPrestacion] = useState(new Date());
    const [fechaPrestacion, setFechaPrestacion] = useState(item?.fechaPrestacion);
    const [enableCheckAfiInexistente, setEnableCheckAfiInexistente] = useState(item?.afiliadoInexistente ? true : false);
    const [enableCheckPractInexistente, setEnableCheckPractInexistente] = useState(item?.practicaInexistente ? true : false);
    const [practInexistente, setPractInexistente] = useState(item?.practicaInexistente);
    const [practicaTemp, setPracticaTemp] = useState();
    const [idObraSocial, setIdObraSocial] = useState(item?.afiliadoInexistente ? '' : OBRAS_SOCIALES.OSPEDYC);

    const handleUpdateLinePrestacion = () => {
       
        if (tipoLinea === TIPO_LINEA.IdSolicitud) {
            if (!idSolicitud || idSolicitud === '' || Number(idSolicitud) === 0)
                dispatch(startAlerta('Ingrese un IdSolicitud válido', "warning", "Error"));
        } else if (!soloPrecarga) {
            if (!esLineaCodigoLiq && ((!afiliadoTemp?.id_afiliado) && (!afiliadoExternoTemp?.id_afiliado)) && !enableCheckAfiInexistente ) {
                return dispatch(startAlerta("Debe seleccionar un afliliado para grabar la línea.", "warning", "Error"));
            // } else if (!importe || importe === 0) {
            //     return dispatch(startAlerta("Debe ingresar un importe.", "warning", "Error"));
            } else if (fechaPrestacion === null) {
                return dispatch(startAlerta("La fecha de prestación no puede estar vacía.", "warning", "Error"));
            }

            if (lineaComprobante === LIQUIDACIONES_LINEA_COMPORBANTE.PRESTACION) {
                if (enableCheckPractInexistente === false && !codigoPractica) {
                  return dispatch(startAlerta("Debe seleccionar una práctica.", "warning", "Error"));
                }
                
                dispatch(modificarLineaPrestacion(item.idItem, item.idComprobante, fechaPrestacion, codigoPractica?.id, cantidad, importe, afiliadoTemp?.id_afiliado, afiInexistente,
                    item?.idSolicitud, idCategoria  ,coseguroFacturado, practInexistente, item?.nroValidacion, setImporteDebito, importeDebito, afiliadoExternoTemp?.id_afiliado ))
                closeModal();
              } else if (lineaComprobante === LIQUIDACIONES_LINEA_COMPORBANTE.INSUMO) {
                if (!codigoMaterial) {
                  return dispatch(startAlerta("Debe seleccionar un insumo.", "warning", "Error"));
                }
                dispatch(modificarLineaInsumo(item.idItem, item.idComprobante ,fechaPrestacion, codigoMaterial?.codigoNum, cantidad, importe, afiliadoTemp?.id_afiliado,
                 item?.nroValidacion, item?.idSolicitud, afiInexistente, importeDebito, setImporteDebito ))
                closeModal();
              }

        }
        }

        const closeModal = () => {
            setCodigoPractica(null);
            closeModalHandler();
        }

        useEffect(() => {
          setIdObraSocial(item?.idAfiliado ? OBRAS_SOCIALES.OSPEDYC : item?.idAfiliadoExterno ? OBRAS_SOCIALES.OSOCNA : '')
        }, [item])

        console.log("afi externo", afiliadoExternoTemp)
        console.log("esLineaCodigoLiq", esLineaCodigoLiq)
        console.log("afi ", afiliadoTemp)
        console.log("afi ", item)
        return (
            <Dialog
                fullWidth
                open={open}
                maxWidth={'md'}
                onClose={closeModalHandler}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{`${title}`}</DialogTitle>
                <DialogContent>
                    <Grid
                        container
                        spacing={2}
                        style={{ width: "60%", margin: "auto", marginBottom: 25 }}
                    >
                        <Grid item xs={12}>
                            {tipoLinea === TIPO_LINEA.IdSolicitud
                                ?
                                <TextField
                                    variant="outlined"
                                    margin="normal"
                                    type='number'
                                    fullWidth
                                    label="IdSolicitud"
                                    name="idSolicitud"
                                    value={idSolicitud}
                                    autoComplete="off"
                                    autoFocus
                                    onChange={(e) => setIdSolicitud(e.target.value)}
                                    onKeyPress={(e) => {
                                        if (e.key === "Enter")
                                            handleUpdateLinePrestacion();
                                    }}
                                />
                                :
                                lineaComprobante === LIQUIDACIONES_LINEA_COMPORBANTE.PRESTACION
                                    ?

                                    <BuscadorPractica
                                        liquidaciones={true}
                                        cod={codigoPractica}
                                        label="Código Practica"
                                        fieldsDisabled={enableCheckPractInexistente ? true : false}
                                        esLineaCodigoLiq={esLineaCodigoLiq}
                                        setCod={(val) => setCodigoPractica(val)}
                                        idTipoNomenclador={comprobanteSeleccionado?.comprobanteContrato?.efectorFacturacion?.idTipoNomenclador}
                                        idEfectorFacturacion={comprobanteSeleccionado?.comprobanteContrato?.efectorFacturacion?.idEfectorFacturacion}

                                    />
                                    :
                                    lineaComprobante === LIQUIDACIONES_LINEA_COMPORBANTE.INSUMO
                                        ?
                                        <BuscadorMateriales
                                            cod={codigoMaterial}
                                            label="Código Material"
                                            fieldsDisabled={props.esDenunciaInternacion}
                                            setCod={(val) => setCodigoMaterial(val)}
                                        />
                                        :
                                        null
                            }
                        </Grid>
                        {/* {!soloPrecarga && */}
                        <ModalAddLineCampos
                            lineaExistente={false}
                            esLineaCodigoLiq={esLineaCodigoLiq}
                            lineaComprobante={lineaComprobante}
                            comprobanteSeleccionado={comprobanteSeleccionado}
                            importe={importe}
                            setImporte={setImporte}
                            cantidad={cantidad}
                            setCantidad={setCantidad}
                            idCategoria={idCategoria}
                            setIdCategoria={setIdCategoria}
                            afiliadoTemp={afiliadoTemp}
                            setAfiliadoTemp={setAfiliadoTemp}
                            nroValidacion={nroValidacion}
                            setNroValidacion={setNroValidacion}
                            afiInexistente={afiInexistente}
                            setAfiInexistente={setAfiInexistente}
                            fechaPrestacion={fechaPrestacion}
                            setFechaPrestacion={setFechaPrestacion}
                            idSolicitudLinea={idSolicitudLinea}
                            setIdSolicitudLinea={setIdSolicitudLinea}
                            enableCheckAfiInexistente={enableCheckAfiInexistente}
                            setEnableCheckAfiInexistente={setEnableCheckAfiInexistente}
                            enableCheckPractInexistente={enableCheckPractInexistente}
                            setEnableCheckPractInexistente={setEnableCheckPractInexistente}
                            coseguroFacturado={coseguroFacturado}
                            setCoseguroFacturado={setCoseguroFacturado}
                            practInexistente={practInexistente}
                            setPractInexistente={setPractInexistente}
                            practicaTemp={practicaTemp}
                            setPracticaTemp={setPracticaTemp}
                            codigoPractica={codigoPractica}
                            soloPrecarga={soloPrecarga}
                            setSoloPrecarga={setSoloPrecarga}
                            afiliadoExternoTemp={afiliadoExternoTemp}
                            setAfiliadoExternoTemp={setAfiliadoExternoTemp}
                            idObraSocial={idObraSocial}
                        />
                        {/* } */}
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Grid container justify="center" style={{ marginBottom: 10 }}>
                        <Grid item xs={4}>
                            <Button
                                style={{ marginLeft: '15%' }}
                                onClick={closeModal}
                                variant="contained"
                                color="primary"
                            >
                                Cerrar
                            </Button>
                        </Grid>
                        {/* <Grid item xs={4} style={{ textAlign: 'center' }}>
                        {tipoLinea !== TIPO_LINEA.IdSolicitud &&
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        name="soloPrecarga"
                                        checked={soloPrecarga}
                                        disabled={tipoLinea === TIPO_LINEA.IdSolicitud}
                                        onChange={(e) => {
                                            setSoloPrecarga(e.target.checked);
                                        }}
                                    />
                                }
                                label="Solo-PreCarga"
                            />
                        }
                    </Grid> */}
                        <Grid item xs={4} style={{ textAlign: 'right' }}>
                            <Button
                                color="primary"
                                variant="contained"
                                style={{ marginRight: '15%' }}
                                onClick={handleUpdateLinePrestacion}
                            >
                                Modificar
                            </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
        )
    }
